import axios from "@/utils/axios";

const API_URL = process.env.VUE_APP_API_URL || "";

export const getStockData = async () => {
  const response = await axios.get(`${API_URL}/stocks`, {
    params: { _t: Date.now() },
  });
  return Array.isArray(response.data) ? response.data : response.data?.data || [];
};

export const createStock = async (data) => {
  const response = await axios.post(`${API_URL}/stocks`, data);
  return response.data?.data || response.data;
};

export const deleteStock = async (id) => {
  const response = await axios.delete(`${API_URL}/stocks/${id}`);
  return response.data;
};

export const updateStock = async (id, data) => {
  const response = await axios.put(`${API_URL}/stocks/${id}`, data);
  return response.data?.data || response.data;
};

export const getInventoryDashboard = async () => (await axios.get(`${API_URL}/inventory/dashboard`)).data;
export const getStockMovements = async (params = {}) => (await axios.get(`${API_URL}/inventory/movements`, { params })).data;
export const adjustStock = async (data) => (await axios.post(`${API_URL}/inventory/adjustments`, data)).data;
export const transferStock = async (data) => (await axios.post(`${API_URL}/inventory/transfers`, data)).data;
